"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("../components/abstractComponent"));
var InputFilled = /** @class */ (function (_super) {
    __extends(InputFilled, _super);
    function InputFilled() {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        _this.body = document.body;
        _this.elements = _this.body.querySelectorAll('input, textarea, select');
        (_a = _this.elements) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            if (element.type !== 'checkbox' && element.type !== 'radio' && element.type !== 'hidden') {
                _this.isFilled(element);
                InputFilled.changeClass(element);
            }
        });
        return _this;
    }
    InputFilled.prototype.isFilled = function (element) {
        element === null || element === void 0 ? void 0 : element.addEventListener('blur', function () {
            InputFilled.changeClass(element);
        });
    };
    InputFilled.changeClass = function (element) {
        var value = element === null || element === void 0 ? void 0 : element.value;
        if (value.length > 0) {
            element === null || element === void 0 ? void 0 : element.classList.add('is-filled');
        }
        else {
            element === null || element === void 0 ? void 0 : element.classList.remove('is-filled');
        }
    };
    return InputFilled;
}(abstractComponent_1.default));
exports.default = InputFilled;
